
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/b2b/[productId]",
      function () {
        return require("private-next-pages/checkout/b2b/[productId].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/b2b/[productId]"])
      });
    }
  